import { gql } from '@apollo/client'

export const TOGGLE_CONTENT_MARK = gql`
  mutation toggleContentMark($input: ToggleContentMarkInput!) {
    toggleContentMark(input: $input)
  }
`
